<script lang="ts">
	import { Badge } from "flowbite-svelte";
	import { twMerge } from "tailwind-merge";
</script>

<Badge {...$$restProps} class={twMerge("h-6 gap-1", $$restProps.dismissable ? "pr-1" : "", $$restProps.class)} on:close on:click>
	<slot />
</Badge>
